module.exports = __webpack_public_path__ + "img/coin-piles.1dd697f8.svg";